import Enum from "../../../../../../enums/Enum";

const RiskLevelEnum = new Enum({
    HIGH: {name: "High Risk", className: "riskLevelTextDivRed", headerClassName: "disc-danger"},
    MODERATE: {name: "Moderate", className: "riskLevelTextDivOrange", headerClassName: "moderate-risk"},
    LOW: {name: "Low Risk", className: "riskLevelTextDivGreen", headerClassName: "disc-green"}
});

export default RiskLevelEnum;